const LK_TEST_ESKSO = 'test-lk.eskso.ru';
const LK_PROD_ESKSO = 'lk.eskso.ru';
const LK_STAGE_ESKSO = 'stage-lk.eskso.ru';
const LK_SANDBOX = 'eskso2.sapfir.corp';
const DEV_URL = 'localhost:3000';

export function checkEsiaRedirectUrl(url: string): boolean {
  const host = url.replace(/https?:\/\//, '');

  return (
    !!host &&
    (host.startsWith(LK_PROD_ESKSO) ||
      host.startsWith(LK_TEST_ESKSO) ||
      host.startsWith(LK_STAGE_ESKSO) ||
      host.startsWith(LK_SANDBOX) ||
      host.startsWith(DEV_URL))
  );
}
